import { Component, Input } from '@angular/core';

@Component({
  selector: 'live-video',
  templateUrl: './live-video.component.html',
  styleUrls: ['./live-video.component.css'],
})
export class LiveVideoComponent {

  @Input() public videoWidth: string = '80%';
  @Input() public videoHeight: string = '219';

  constructor() {}

}
